import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, PROJECTLOGOPRIMARY, PROJECTCAPTCHASITEKEY, NFTAPIBASENAME, MAXTIMELIMITFOREMAILOTP, MAXTIMELIMITFORPHONEOTP, PROJECTCLIENTSIDEURL, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, sendOtpInEmail, sendOtpInPhone, checkIfUserIsLoggedIn, getAllSessionData, getBlockChainContract } from '../helpers/Library';
import Loader from '../commons/Loader';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import axios from "axios";
import { connect } from 'react-redux';
import store from '../redux/store'
import { setMetaMask, setBlockChainContract } from "../redux/action"
import { useDispatch } from 'react-redux';
import { stringify } from 'flatted';
import web3 from "web3";


const Main = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [isEmailOtpButtonEnabled, setEmailOtpButtonEnable] = useState(true);
    const [isPhoneOtpButtonEnabled, setPhoneOtpButtonEnable] = useState(true);
    const [showOtpSubmitButton, setShowOtpSubmitButton] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [captcha, setCaptcha] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [country, setCountry] = useState('');
    const [ipAddress, setIpAddress] = useState('');
    const [is2FaEnabled, set2FaEnabledStatus] = useState(false);
    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [emailOtp, setEmailOtp] = useState('');
    const [phoneOtp, setPhoneOtp] = useState('');
    const [googleAuthOtp, setGoogleAuthOtp] = useState('');
    const [emailOtpTimerText, setEmailOtpTimerText] = useState('');
    const [phoneOtpTimerText, setPhoneOtpTimerText] = useState('');
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    const [artCollections, setArtCollections] = useState([]);
    const [musicCollections, setMusicCollections] = useState([]);
    const [photographyCollections, setPhotographyCollections] = useState([]);
    const [categories, setCategories] = useState([]);
    const [trendingCollections1, setTrendingCollections1] = useState([]);
    const [trendingCollections2, setTrendingCollections2] = useState([]);
    /* Method defiantion for draging slider */
    const handleDragStart = (e) => e.preventDefault();

    /*method for getting all collections by category*/
    //    let getColletionListByCategory = (categoryId) => {
    //     let payload= {"userUuid":getAllSessionData().uuid,"pageNo":pageNo,"pageSize":pageSize,"entityId" : categoryId}
    //     setShowLoader(true)
    //     console.log(payload)
    //     setSelectedCategory(categoryId)
    //     callAPI('post', NFTAPIBASENAME + '/nft/market/getAllCollectionByCategory', payload, true).then((res) => {
    //         let response = res.data;
    //         setShowLoader(false);
    //         console.log(response);
    //         if (response.error.error_data != 0) {
    //             showToast('error', response.error.error_msg)
    //         } else {
    //             if(response.nftCollections != undefined && response.nftCollections != null){
    //                 setNftCollections(response.nftCollections)
    //             }else{
    //                 setNftCollections([])
    //             }
    //         }

    //     }, (error) => {
    //         setShowLoader(false);
    //         showHttpError(error)
    //     })

    // }

    /* method for getting list of arts collections */

    const getArtCollections = () => {
        let payload = { "pageNo": pageNo, "pageSize": pageSize, "entityId": "1" }
        setShowLoader(true)
        console.log('FOR GETTING ART LIST PAYLOAD', payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllCollectionByCategory', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setArtCollections(response.nftCollections)
                } else {
                    setArtCollections([])
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* method for getting list of music collections */

    const getMusicCollections = () => {
        let payload = { "pageNo": pageNo, "pageSize": pageSize, "entityId": "6" }
        setShowLoader(true)
        console.log('FOR GETTING ART LIST PAYLOAD', payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllCollectionByCategory', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setMusicCollections(response.nftCollections)
                } else {
                    setMusicCollections([])
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }
    /* Method defination for getting trending Collections */
    let getAllTrendingCollections = () => {
        let payload = {}
        setShowLoader(true);
        callAPI('get', NFTAPIBASENAME + '/nft/market/public/getTrendingCollections', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != null) {
                    let arr1 = [];
                    let arr2 = [];
                    let diffLength = Math.ceil(response.nftCollections.length) / 2;
                    console.log(diffLength);
                    for (let i = 0; i < diffLength; i++) {
                        response.nftCollections[i]['rank'] = i + 1
                        arr1.push(response.nftCollections[i])
                    }
                    setTrendingCollections1(arr1)
                    for (let i = diffLength; i < response.nftCollections.length; i++) {
                        response.nftCollections[i]['rank'] = i + 1
                        arr2.push(response.nftCollections[i])
                    }
                    console.log(arr2)
                    setTrendingCollections2(arr2)
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }
    const getPhotographyCollections = () => {
        let payload = { "pageNo": pageNo, "pageSize": pageSize, "entityId": "5" }
        setShowLoader(true)
        console.log('FOR GETTING ART LIST PAYLOAD', payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllCollectionByCategory', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setPhotographyCollections(response.nftCollections)
                } else {
                    setPhotographyCollections([])
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* Method defination for get all category */
    let getAllCategoryList = () => {
        let payload = {}
        setShowLoader(true)
        callAPI('get', NFTAPIBASENAME + '/nft/market/public/getAllCollectionCategory', false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.collectionCategories != undefined && response.collectionCategories != null) {
                    let cat = [];
                    for (let i = 0; i < 4; i++) {
                        cat.push(response.collectionCategories[i])
                    }
                    setCategories(cat)
                    //console.log('cat',categories)
                } else {
                    setCategories([])
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }


    /* Setting up notable nft list for sliders  */
    let notableNftLists = [
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">
                        {/* <div className="type-lb">
                            <p className="sale">Sale</p>
                        </div> */}
                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li> */}
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                            {/* <a className="cart" href="#">Add to Cart</a> */}
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                        {/* <h5> 0.01 ETH</h5> */}
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>

                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,
        <Fragment>

            <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">
                <div className="products-single fix">
                    <div className="box-img-hover">

                        <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                        <div className="mask-icon">
                            <ul>
                                <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="why-text">
                        <h4>Lorem ipsum dolor sit amet</h4>
                    </div>
                </div>
            </div>
        </Fragment>,



    ];

    const responsiveForSliders = {
        0: { items: 1 },
        568: { items: 3 },
        1024: { items: 5 },
    }

    /*  Method defination for getting user ip */
    async function getIP() {
        await callAPI('GET', 'https://jsonip.com', {}, false).then((res) => {
            let response = res.data;
            console.log(response);
            setIpAddress(response.ip);
        })
    }




    /* Method defination for handling check 2fa status api call */
    let handlePreLoginCheck = () => {
        let payload = {}
        payload['user_name'] = username;
        payload['password'] = password;
        payload['ip_address'] = ipAddress;
        payload['latitude'] = latitude;
        payload['longitude'] = longitude;
        payload['location'] = country;
        payload['gRecaptcha'] = captcha;
        setShowLoader(true)
        callAPI('POST', NFTAPIBASENAME + '/adminAccess/check2faStatus', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            if (response.error.error_data != '0') {
                showToast('error', response.error.error_msg);
            } else {
                if (response.adminUsersResult.enabled2fa == 1) {
                    set2FaEnabledStatus(true)
                } else {
                    set2FaEnabledStatus(false)
                }
                setShowOtpPopup(true)
            }
        }).catch(
            function (err) {
                setShowLoader(false)
                showHttpError(err)
            }.bind(this)
        );
    }


   


    const getAllCollections = async () => {
        try {
            // Only attempt contract connection if ethereum is available
            let contract = null;
            if (typeof window !== 'undefined' && window.ethereum) {
                try {
                    contract = await getBlockChainContract(false);
                } catch (contractErr) {
                    console.warn('Could not connect to blockchain contract:', contractErr);
                }
            }

            const query = `
            {
              collections {
                id
                name
                description
                backgroundImage
                creator
                volume
                nfts {
                  id
                  tokenURI
                  price
                  owner
                }
              }
            }
          `;

            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const allCollections = response.data.data.collections;
            // Process collections and their NFTs
            let rank = 1;
            const processedCollections = await Promise.all(
                allCollections.map(async (collection) => {
                    // Fetch the floor bid for this collection using the smart contract method
                    let floorBidObj = {}
                    if (contract) {
                        try {
                            const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                            console.log('floorBidData', floorBidData);
                            const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;
                            floorBidObj = {
                                bidder: floorBidData.bidder,
                                bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                                expirationTime: floorBidData.expirationTime,
                                isExpired: isFloorBidExpired,
                            };
                        } catch (floorBidErr) {
                            console.warn('Could not fetch floor bid for collection', collection.id, ':', floorBidErr);
                        }
                    }

                    return {
                        id: collection.id,
                        rank : rank++,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: floorBidObj,
                    };
                })
            );

            console.log('All Collections:', processedCollections);
            //setAllCollections(collections);
            let trendingColl1 = []
            let trendingColl2 = []
            const MAXTRENDINGLIST = 10;
            if (processedCollections != null && processedCollections != undefined) {
                if (processedCollections.length < 10) {
                    let indexToSplit = Math.ceil(processedCollections.length / 2);
                    console.log('indexToSplit => ', indexToSplit)
                    trendingColl1 = processedCollections.slice(0, indexToSplit);
                    trendingColl2 = processedCollections.slice(indexToSplit);
                } else {
                    let colArr = processedCollections.slice(0, MAXTRENDINGLIST);
                    let indexToSplit = Math.ceil(colArr.length / 2);
                    console.log('indexToSplit => ', indexToSplit)
                    trendingColl1 = colArr.slice(0, indexToSplit);
                    trendingColl2 = colArr.slice(indexToSplit);
                }
            }
           // console.log(trendingColl1,trendingColl2)
            setTrendingCollections1(trendingColl1)
            setTrendingCollections2(trendingColl2)
            setArtCollections(processedCollections)
            setMusicCollections(processedCollections)
            setPhotographyCollections(processedCollections)
        } catch (error) {
            showToast('error','Error fetching all collections:'+ error);
        }

    }


    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        // getAllCategoryList();
        // getArtCollections();
        // getMusicCollections();
        // getPhotographyCollections();
        // getAllTrendingCollections();
        getAllCollections()
    }, []);

    return (
        <Fragment>
            <Header />



            {/* Start Slider */}
            <div id="slides-shop" className="cover-slides">
                <ul className="slides-container">
                    <li className="text-center">
                        <img src={require('../assets/images/banner-01.jpg')} className="banner-image-strict" style={{ width: '100%' }} alt="" />
                        <div className="container banner-overlay">
                            <div className="row" style={{ marginTop: '100px' }}>
                                <div className="col-md-12">
                                    <h1 className="m-b-20"><strong>Welcome To <br></br> {localStorage.getItem('nftBrokerExchangeName')} NFT  Marketplace</strong></h1>
                                    <p className="m-b-40">See how your users experience your website in realtime or view <br></br> trends to see any changes in performance over time.</p>

                                </div>
                            </div>
                        </div>
                    </li>
                    {/*  <li className="text-center">
                <img  src={require('../assets/images/banner-02.jpg')} alt=""/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="m-b-20"><strong>Welcome To <br></br> PaybitoPro NFT  Marketplace</strong></h1>
                            <p className="m-b-40">See how your users experience your website in realtime or view <br></br> trends to see any changes in performance over time.</p>
                            <p><a className="btn hvr-hover" href="#">Shop New</a></p>
                        </div>
                    </div>
                </div>
            </li>
            <li className="text-center">
                <img src={require('../assets/images/banner-03.jpg')} alt=""/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="m-b-20"><strong>Welcome To <br></br> PaybitoPro NFT  Marketplace</strong></h1>
                            <p className="m-b-40">See how your users experience your website in realtime or view <br></br> trends to see any changes in performance over time.</p>
                            <p><a className="btn hvr-hover" href="#">Shop New</a></p>
                        </div>
                    </div>
                </div>
            </li> */}
                </ul>
                {/*  <div className="slides-navigation">
            <a href="#" className="next"><i className="fa fa-angle-right" aria-hidden="true"></i></a>
            <a href="#" className="prev"><i className="fa fa-angle-left" aria-hidden="true"></i></a>
        </div> */}
            </div>
            {/* End Slider */}

            {/* Start Categories  */}
            {/* <div className="categories-shop">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="shop-cat-box">
                        <img className="img-fluid" src={require('../assets/images/categories_img_01.jpg')}  alt="" />
                        <a className="btn hvr-hover" href="#">Lorem ipsum dolor</a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="shop-cat-box">
                        <img className="img-fluid" src={require('../assets/images/categories_img_02.jpg')} alt="" />
                        <a className="btn hvr-hover" href="#">Lorem ipsum dolor</a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="shop-cat-box">
                        <img className="img-fluid" src={require('../assets/images/categories_img_02.jpg')} alt="" />
                        <a className="btn hvr-hover" href="#">Lorem ipsum dolor</a>
                    </div>
                </div>
            </div>
        </div>
    </div> */}
            {/* End Categories */}

            <div className="box-add-products">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <table className="table table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" width="10%">Rank</th>
                                        <th scope="col" width="50%">Collection</th>
                                        <th scope="col" width="20%">Floor Price</th>
                                        <th scope="col" width="20%">Volume</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {trendingCollections1.length == 0 ? <tr>
                                        <td colSpan={4} className='text-center'>NO DATA</td>
                                    </tr> : trendingCollections1.map((col, index) => (
                                        <tr style={{ cursor: 'pointer' }} key={col.id}>
                                            <th scope="row" width="10%">{parseInt(col.id) +1}</th>
                                            <td width="50%">
                                                <div className="row">
                                                    <img className="col-md-4" src={col.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt="" height="50px" width="50px" />
                                                    <Link to={`/collections/${col.id}/${col.name}`}>

                                                        <span>{col.name}</span>
                                                    </Link>
                                                </div>
                                            </td>
                                            {col.floorBid.bidder != undefined && col.floorBid.bidder != null && <td width="20%">{col.floorBid.bidder != "0x0000000000000000000000000000000000000000" ?  col.floorBid.bidAmount : 0} ETH</td>}
                                            <td width="20%">{col.volume} ETH</td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <table className="table table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" width="10%">Rank</th>
                                        <th scope="col" width="50%">Collection</th>
                                        <th scope="col" width="20%">Floor Price</th>
                                        <th scope="col" width="20%">Volume</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {trendingCollections2.length == 0 ? <tr>
                                        <td colSpan={4} className='text-center'>NO DATA</td>
                                    </tr> : trendingCollections2.map((col, index) => (
                                        <tr style={{ cursor: 'pointer' }} key={col.id}>
                                            <th scope="row" width="10%">{parseInt(col.id) +1}</th>
                                            <td width="50%">
                                                <div className="row">
                                                    <img className="col-md-4" src={col.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt="" height="50px" width="50px" />
                                                    <Link to={`/collections/${col.id}/${col.name}`}>

                                                        <span>{col.name}</span>
                                                    </Link>
                                                </div>
                                            </td>
                                             {col.floorBid.bidder != undefined && col.floorBid.bidder != null && <td width="20%">{col.floorBid.bidder != "0x0000000000000000000000000000000000000000" ?  col.floorBid.bidAmount : 0} ETH</td>}
                                            <td width="20%">{col.volume} ETH</td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Start Notable section  */}
            <div className="products-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-all text-center">
                                <h1>Notable Collections</h1>

                            </div>
                        </div>
                    </div>


                    <div className="row special-list">

                        <AliceCarousel
                            mouseTracking
                            items={
                                photographyCollections.map((data) => (

                                    <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">

                                        <>
                                            <div className="products-single fix">

                                                <div className="box-img-hover ml-2">
                                                    <img src={data.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ maxWidth: '250px', height: '250px' }} />
                                                    <div className="mask-icon">
                                                        <ul>
                                                            <li><Link to={`/collections/${data.id}/${data.name}`}><i className="fas fa-eye"></i></Link></li>
                                                            {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                                                        </ul>
                                                    </div>

                                                </div>
                                                <Link to={`/collections/${data.id}/${data.name}`}>
                                                    <div className="why-text ml-2">
                                                        <h4>{data.name}</h4>
                                                        {/* <p>Floor Price : {data.floorPrice}</p>
                                                        <p>Volume : {data.totalVolume}</p> */}
                                                    </div>
                                                </Link>
                                            </div>

                                        </>

                                    </div>
                                ))
                            }
                            responsive={responsiveForSliders}
                            controlsStrategy="alternate"
                        />

                    </div>
                </div>
            </div>
            {/* End Notable section  */}
            {/* Start Notable section  */}
            <div className="products-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-all text-center">
                                <h1>Trending in Arts</h1>

                            </div>
                        </div>
                    </div>


                    <div className="row special-list">

                        <AliceCarousel
                            mouseTracking
                            items={
                                artCollections.map((data) => (

                                    <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">

                                        <>
                                            <div className="products-single fix">

                                                <div className="box-img-hover ml-2">
                                                    <img src={data.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                    <div className="mask-icon">
                                                        <ul>

                                                            <li><Link to={`/collections/${data.id}/${data.name}`}><i className="fas fa-eye"></i></Link></li>
                                                            {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}

                                                        </ul>
                                                    </div>
                                                </div>
                                                <Link to={`/collections/${data.nftCollectionId}/${data.name}`}>
                                                    <div className="why-text ml-2">
                                                        <h4>{data.name}</h4>
                                                        {/* <p>Floor Price : {data.floorPrice}</p> */}
                                                        {/* <p>Volume : {data.volume}</p> */}
                                                    </div>
                                                </Link>


                                            </div>

                                        </>

                                    </div>
                                ))
                            }
                            responsive={responsiveForSliders}
                            controlsStrategy="alternate"
                        />

                    </div>
                </div>
            </div>
            {/* End Notable section  */}
            {/* Start Notable section  */}
            <div className="products-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-all text-center">
                                <h1>Trending in Music</h1>

                            </div>
                        </div>
                    </div>


                    <div className="row special-list">

                        <AliceCarousel
                            mouseTracking
                            items={
                                musicCollections.map((data) => (

                                    <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">

                                        <>
                                            <div className="products-single fix">

                                                <div className="box-img-hover ml-2">
                                                    <img src={data.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ maxWidth: '250px', height: '250px' }} />
                                                    <div className="mask-icon">
                                                        <ul>
                                                            {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li> */}
                                                            <li><Link to={`/collections/${data.id}/${data.name}`}><i className="fas fa-eye"></i></Link></li>
                                                            {/*  <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <Link to={`/collections/${data.id}`}>
                                                    <div className="why-text ml-2">
                                                        <h4>{data.name}</h4>
                                                        {/* <p>Floor Price : {data.floorPrice}</p>
                                                        <p>Volume : {data.totalVolume}</p> */}
                                                    </div>
                                                </Link>

                                            </div>

                                        </>

                                    </div>
                                ))
                            }
                            responsive={responsiveForSliders}
                            controlsStrategy="alternate"
                        />

                    </div>
                </div>
            </div>
            {/* End Notable section  */}

            {/* Start Blog  */}
            {/* <div className="latest-blog">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="title-all text-center">
                        <h1>latest blog</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet lacus enim.</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-4 col-xl-4">
                    <div className="blog-box">
                        <div className="blog-img">
                            <img className="img-fluid" src="../assets/images/blog-img.jpg" alt="" />
                        </div>
                        <div className="blog-content">
                            <div className="title-blog">
                                <h3>Fusce in augue non nisi fringilla</h3>
                                <p>Nulla ut urna egestas, porta libero id, suscipit orci. Quisque in lectus sit amet urna dignissim feugiat. Mauris molestie egestas pharetra. Ut finibus cursus nunc sed mollis. Praesent laoreet lacinia elit id lobortis.</p>
                            </div>
                            <ul className="option-blog">
                                <li><a href="#"><i className="far fa-heart"></i></a></li>
                                <li><a href="#"><i className="fas fa-eye"></i></a></li>
                                <li><a href="#"><i className="far fa-comments"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-4">
                    <div className="blog-box">
                        <div className="blog-img">
                            <img className="img-fluid" src="../assets/images/blog-img-01.jpg" alt="" />
                        </div>
                        <div className="blog-content">
                            <div className="title-blog">
                                <h3>Fusce in augue non nisi fringilla</h3>
                                <p>Nulla ut urna egestas, porta libero id, suscipit orci. Quisque in lectus sit amet urna dignissim feugiat. Mauris molestie egestas pharetra. Ut finibus cursus nunc sed mollis. Praesent laoreet lacinia elit id lobortis.</p>
                            </div>
                            <ul className="option-blog">
                                <li><a href="#"><i className="far fa-heart"></i></a></li>
                                <li><a href="#"><i className="fas fa-eye"></i></a></li>
                                <li><a href="#"><i className="far fa-comments"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-4">
                    <div className="blog-box">
                        <div className="blog-img">
                            <img className="img-fluid" src="../assets/images/blog-img-02.jpg" alt="" />
                        </div>
                        <div className="blog-content">
                            <div className="title-blog">
                                <h3>Fusce in augue non nisi fringilla</h3>
                                <p>Nulla ut urna egestas, porta libero id, suscipit orci. Quisque in lectus sit amet urna dignissim feugiat. Mauris molestie egestas pharetra. Ut finibus cursus nunc sed mollis. Praesent laoreet lacinia elit id lobortis.</p>
                            </div>
                            <ul className="option-blog">
                                <li><a href="#"><i className="far fa-heart"></i></a></li>
                                <li><a href="#"><i className="fas fa-eye"></i></a></li>
                                <li><a href="#"><i className="far fa-comments"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> */}
            {/* End Blog  */}


            {/* Start Instagram Feed  */}
            {/* <div className="instagram-box">
        <div className="main-instagram owl-carousel owl-theme">
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-01.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-02.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-03.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-04.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-05.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-06.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-07.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-08.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-09.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="ins-inner-box">
                    <img src="../assets/images/instagram-img-05.jpg" alt="" />
                    <div className="hov-in">
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div> */}
            {/* End Instagram Feed  */}



            <Footer />
            <Loader show={showLoader} />
        </Fragment >
    );
}
const mapStateToProps = state => {
    return {
        store: state
    }
}
export default connect(mapStateToProps)(Main);